<div class="container new-announcement-container">
  <div *ngIf="!showSuccess; else successScreen">
    <h1 class="page-title">{{ isEditMode ? 'Elanı redaktə et' : 'Yeni elan' }}</h1>

    <form [formGroup]="announcementForm" (ngSubmit)="onSubmit()" class="announcement-form">
      <!-- 6.1 Elan tipi -->
      <section class="form-section">
        <h3>Elan tipi</h3>
        <div class="type-selector">
          <label class="type-tab" [class.active]="announcementType === 'sale'">
            <input type="radio" formControlName="type" value="sale"> Satıram
          </label>
          <label class="type-tab" [class.active]="announcementType === 'rent'">
            <input type="radio" formControlName="type" value="rent"> Kirayə verirəm
          </label>
        </div>
      </section>

      <!-- 6.2 Əsas məlumatlar və yerləşmə -->
      <section class="form-section">
        <h3>Əsas məlumatlar və yerləşmə</h3>

        <div class="form-grid">
          <div class="form-group">
            <label>Əmlakın növü *</label>
            <select formControlName="propertyType" [class.error]="isSubmitted && announcementForm.get('propertyType')?.invalid">
              <option value="">Seçin</option>
              <option *ngFor="let type of propertyTypes" [value]="type.id">{{type.name}}</option>
            </select>
          </div>

          <div class="form-group">
            <label>Şəhər *</label>
            <select formControlName="cityId" (change)="onCityChange()" [class.error]="isSubmitted && announcementForm.get('cityId')?.invalid">
              <option [ngValue]="null">Seçin</option>
              <option *ngFor="let area of cities" [value]="area.id">{{area.name}}</option>
            </select>
          </div>

          <div class="form-group" *ngIf="districts.length > 0">
            <label>Rayon *</label>
            <select formControlName="districtId" (change)="onDistrictChange()" [class.error]="isSubmitted && announcementForm.get('districtId')?.invalid">
              <option [ngValue]="null">Seçin</option>
              <option *ngFor="let d of districts" [value]="d.id">{{d.name}}</option>
            </select>
          </div>

          <div class="form-group" *ngIf="settlements.length > 0">
            <label>Qəsəbə</label>
            <select formControlName="settlementId" (change)="onSettlementChange()" [class.error]="isSubmitted && announcementForm.get('settlementId')?.invalid">
              <option [ngValue]="null">Seçin</option>
              <option *ngFor="let s of settlements" [value]="s.id">{{s.name}}</option>
            </select>
          </div>


          <div class="form-group full-width">
            <label>Ünvan *</label>
            <input type="text" formControlName="address" placeholder="Dəqiq ünvanı daxil edin" [class.error]="isSubmitted && announcementForm.get('address')?.invalid">
          </div>
        </div>

        <div class="map-block">
          <button type="button" class="btn-map" (click)="showOnMap()" [disabled]="isMapLoading()">
            <i class="fas" [class.fa-map-marked-alt]="!isMapLoading()" [class.fa-spinner]="isMapLoading()" [class.fa-spin]="isMapLoading()"></i>
            {{ isMapLoading() ? 'Yüklənir...' : 'Xəritədə göstər' }}
          </button>
        </div>
      </section>

      <!-- 6.3 Əmlak haqqında (Dinamik) -->
      <section class="form-section" *ngIf="announcementForm.get('propertyType')?.value">
        <h3>Əmlak haqqında</h3>

        <div class="form-grid">
          <!-- Ofis üçün obyekt növü (ID: 4) -->
          <div class="form-group full-width" *ngIf="announcementForm.get('propertyType')?.value == 4">
            <label>Ofisin yerləşdiyi obyekt *</label>
            <div class="segmented-control">
              <label *ngFor="let type of officeObjectTypes"
                     [class.active]="announcementForm.get('officeObjectType')?.value === type"
                     [class.disabled]="announcementForm.get('officeObjectType')?.disabled">
                <input type="radio" formControlName="officeObjectType" [value]="type"> {{type}}
              </label>
            </div>
          </div>

          <!-- Otaq sayı (Torpaq ID: 6 və Qaraj ID: 5 istisna) -->
          <div class="form-group" *ngIf="![5, 6].includes(+announcementForm.get('propertyType')?.value)">
            <label>Otaq sayı *</label>
            <input type="number" formControlName="rooms" placeholder="Məs: 3" [class.error]="isSubmitted && announcementForm.get('rooms')?.invalid">
          </div>

          <!-- Sahə m2 (Torpaq ID: 6 istisna) -->
          <div class="form-group" *ngIf="announcementForm.get('propertyType')?.value != 6">
            <label>Sahə, m² *</label>
            <input type="number" formControlName="area_m2" placeholder="Məs: 85" [class.error]="isSubmitted && announcementForm.get('area_m2')?.invalid">
          </div>

          <!-- Torpaq sahəsi (Torpaq ID: 6 və Həyət evi ID: 3 üçün) -->
          <div class="form-group" *ngIf="[6, 3].includes(+announcementForm.get('propertyType')?.value)">
            <label>Torpağın sahəsi, sot *</label>
            <input type="number" formControlName="land_area_sot" placeholder="Məs: 6" [class.error]="isSubmitted && announcementForm.get('land_area_sot')?.invalid">
          </div>

          <!-- Mərtəbə (Yeni ID: 1, Köhnə ID: 2, Ofis ID: 4 və Obyekt ID: 7 üçün) -->
          <div class="form-group" *ngIf="[1, 2, 4, 7].includes(+announcementForm.get('propertyType')?.value)">
            <label>Mərtəbə</label>
            <input type="number" formControlName="floor" placeholder="Məs: 5" [class.error]="isSubmitted && announcementForm.get('floor')?.invalid">
          </div>

          <!-- Mərtəbələrin sayı (Yeni ID: 1, Köhnə ID: 2, Həyət evi ID: 3, Ofis ID: 4 və Obyekt ID: 7 üçün) -->
          <div class="form-group" *ngIf="[1, 2, 3, 4, 7].includes(+announcementForm.get('propertyType')?.value)">
            <label>Binanın/Evin cəmi mərtəbə sayı</label>
            <input type="number" formControlName="total_floors" placeholder="Məs: 16" [class.error]="isSubmitted && announcementForm.get('total_floors')?.invalid">
          </div>

          <!-- Təmir (Torpaq ID: 6 və Qaraj ID: 5 istisna) -->
          <div class="form-group full-width" *ngIf="![6, 5].includes(+announcementForm.get('propertyType')?.value)">
            <label>Təmir *</label>
            <div class="segmented-control">
              <label *ngFor="let status of renovationStatuses"
                     [class.active]="announcementForm.get('repair')?.value == status.id"
                     [class.disabled]="announcementForm.get('repair')?.disabled">
                <input type="radio" formControlName="repair" [value]="status.id"> {{status.name}}
              </label>
            </div>
          </div>
        </div>
      </section>

      <!-- 6.4 Şəkillər -->
      <section class="form-section">
        <h3>Şəkillər</h3>
        <app-image-upload
          [initialImages]="uploadedImages()"
          (imagesChanged)="onImagesChanged($event)"
          (urlsChanged)="onUrlsChanged($event)">
        </app-image-upload>
        <div class="error-text" *ngIf="isSubmitted && announcementForm.get('mediaIds')?.invalid">
          <span *ngIf="announcementForm.get('mediaIds')?.errors?.['minImages']">Zəhmət olmasa minimum {{announcementForm.get('mediaIds')?.errors?.['minImages'].required}} şəkil əlavə edin</span>
          <span *ngIf="announcementForm.get('mediaIds')?.errors?.['maxImages']">Maksimum {{announcementForm.get('mediaIds')?.errors?.['maxImages'].required}} şəkil əlavə edə bilərsiniz</span>
          <span *ngIf="announcementForm.get('mediaIds')?.errors?.['required']">Zəhmət olmasa şəkil əlavə edin</span>
        </div>
      </section>

      <!-- 6.5 Əlavə məlumat -->
      <section class="form-section">
        <h3>Əlavə məlumat</h3>
        <div class="form-group full-width">
          <textarea formControlName="description" rows="6" maxlength="3000" placeholder="Əmlak barədə ətraflı məlumat daxil edin. Məsələn: təmiri, ətrafdakı infrastruktur və s." [class.error]="isSubmitted && announcementForm.get('description')?.invalid"></textarea>
          <div class="char-counter">
            <span class="warning">Telefon nömrəsi, e-mail qeyd etməyin</span>
            <span>{{Math.max(0, 3000 - (announcementForm.get('description')?.value?.length || 0))}} simvol qalıb</span>
          </div>
        </div>
      </section>

      <!-- 6.6 Qiymət -->
      <section class="form-section">
        <h3>Qiymət</h3>

        <div class="price-container">
          <div class="form-group" *ngIf="announcementType === 'rent'">
            <label>Kirayə müddəti *</label>
            <select formControlName="rentDuration">
              <option *ngFor="let duration of rentDurations" [value]="duration.id">{{duration.name}}</option>
            </select>
          </div>

          <div class="form-group">
            <label>
              Qiymət, ₼
              <span *ngIf="announcementType === 'rent'">
                /{{announcementForm.get('rentDuration')?.value === 'daily' ? 'gün' : 'ay'}}
              </span> *
            </label>
            <input type="number" formControlName="price" placeholder="Məs: 150000" [class.error]="isSubmitted && announcementForm.get('price')?.invalid">
          </div>
        </div>

        <div class="checkbox-group" *ngIf="announcementType === 'sale'">
          <label class="checkbox-label">
            <input type="checkbox" formControlName="hasExtract"> Çıxarış (Kupça) var
          </label>
          <label class="checkbox-label">
            <input type="checkbox" formControlName="hasMortgage"> İpotekaya yararlıdır
          </label>
        </div>
      </section>

      <!-- 6.7 Əlaqə məlumatları -->
      <section class="form-section" *ngIf="!isEditMode">
        <h3>Əlaqə məlumatları</h3>

        <div class="form-grid">
          <div class="form-group full-width">
            <div class="segmented-control">
              <label [class.active]="announcementForm.get('ownerType')?.value === 'owner'"
                     [class.disabled]="announcementForm.get('ownerType')?.disabled">
                <input type="radio" formControlName="ownerType" value="owner"> Elanın sahibi
              </label>
              <label [class.active]="announcementForm.get('ownerType')?.value === 'agent'"
                     [class.disabled]="announcementForm.get('ownerType')?.disabled">
                <input type="radio" formControlName="ownerType" value="agent"> Mən vasitəçiyəm (Agent)
              </label>
            </div>
            <div *ngIf="isSubmitted && announcementForm.get('ownerType')?.invalid" class="error-text">Zəhmət olmasa statusunuzu seçin</div>
          </div>

          <div class="form-group">
            <label>Ad *</label>
            <input type="text" formControlName="contactName" placeholder="Məs: Əli" [class.error]="isSubmitted && announcementForm.get('contactName')?.invalid" [readonly]="isAuthenticated()">
          </div>

          <div class="form-group">
            <label>E-mail *</label>
            <input type="email" formControlName="contactEmail" placeholder="example@gmail.com" [class.error]="isSubmitted && announcementForm.get('contactEmail')?.invalid">
            <div class="error-message" *ngIf="isSubmitted && announcementForm.get('contactEmail')?.invalid">
              <span *ngIf="announcementForm.get('contactEmail')?.errors?.['required']">E-mail daxil edilməlidir.</span>
              <span *ngIf="announcementForm.get('contactEmail')?.errors?.['email']">Düzgün e-mail formatı daxil edin.</span>
            </div>
          </div>

          <div class="form-group">
            <label>Telefon nömrəsi *</label>
            <input type="text" formControlName="contactPhone" (input)="onPhoneInput($event)" placeholder="+994 (__) ___-__-__" [class.error]="isSubmitted && announcementForm.get('contactPhone')?.invalid" [readonly]="isAuthenticated()">
            <div class="error-message" *ngIf="isSubmitted && announcementForm.get('contactPhone')?.invalid">
              <span *ngIf="announcementForm.get('contactPhone')?.errors?.['required']">Telefon nömrəsi daxil edilməlidir.</span>
              <span *ngIf="announcementForm.get('contactPhone')?.errors?.['pattern']">Düzgün operator daxil etməmisiniz.</span>
            </div>
          </div>
        </div>
      </section>

      <div class="form-footer">
        <p class="agreement-text">
          "{{ isEditMode ? 'Yadda saxla' : 'Davam etmək' }}" düyməsinə basmaqla siz <a href="#">istifadəçi razılaşması</a> və <a href="#">qaydalar</a> ilə tam razı olduğunuzu təsdiqləyirsiniz.
        </p>
        <button type="submit" class="btn-large" [disabled]="isFormInvalid || isLoading || (isEditMode && !isFormDirty)">
          <i class="fas fa-spinner fa-spin" *ngIf="isLoading"></i>
          {{ isLoading ? 'Göndərilir...' : (isEditMode ? 'Yadda saxla' : 'Davam etmək') }}
        </button>
      </div>
    </form>

    <app-map-picker
      *ngIf="showMapPicker()"
      [lat]="announcementForm.get('latitude')?.value || 40.4093"
      [lng]="announcementForm.get('longitude')?.value || 49.8671"
      (onLocationSelected)="onLocationSelected($any($event))"
      (onClose)="showMapPicker.set(false)">
    </app-map-picker>
  </div>

  <!-- 6.8 Uğurlu göndəriş ekranı -->
  <ng-template #successScreen>
    <div class="success-screen">
      <div class="success-banner">
        <i class="fas fa-check-circle"></i>
        <div class="banner-content">
          <h4>Təbriklər! Elan sorğunuz qəbul edildi</h4>
          <p *ngIf="isAuthenticated()">Elanınız moderasiyaya göndərildi. Təsdiqləndikdən sonra saytda aktiv olacaq.</p>
          <p *ngIf="!isAuthenticated()">Elanınız yaradıldı. Sizin üçün avtomatik profil açıldı və giriş məlumatları (şifrə) telefon nömrənizə SMS vasitəsilə göndərildi.</p>
          <p><strong>Elanın nömrəsi: xxxx</strong></p>
        </div>
      </div>

      <div class="preview-card">
        <h3>Elanın önbaxışı</h3>
        <div class="preview-content">
          <div class="preview-image">
            <img *ngIf="uploadedImageUrls().length > 0; else noImage" [src]="uploadedImageUrls()[0]" alt="Preview">
            <ng-template #noImage><i class="fas fa-image"></i></ng-template>
          </div>
          <div class="preview-info">
            <div class="preview-price">
              {{announcementForm.get('price')?.value | number}} ₼
              <span class="rent-label" *ngIf="announcementType === 'rent'">
                /{{announcementForm.get('rentDuration')?.value === 'daily' ? 'gün' : 'ay'}}
              </span>
            </div>
            <div class="preview-details">
              <span *ngIf="announcementForm.get('rooms')?.value">{{announcementForm.get('rooms')?.value}} otaqlı • </span>
              <span *ngIf="announcementForm.get('area_m2')?.value">{{announcementForm.get('area_m2')?.value}} m² • </span>
              <span *ngIf="announcementForm.get('floor')?.value">{{announcementForm.get('floor')?.value}}/{{announcementForm.get('total_floors')?.value}} mərtəbə</span>
              <span *ngIf="announcementForm.get('land_area_sot')?.value">{{announcementForm.get('land_area_sot')?.value}} sot</span>
            </div>
            <div class="preview-address">
              {{announcementForm.get('address')?.value}}
            </div>
          </div>
        </div>
      </div>

      <div class="success-actions">
        <button class="btn btn-primary" (click)="showSuccess = false">
          <i class="fas fa-plus"></i> Yeni elan yarat
        </button>
        <button *ngIf="isAuthenticated()" class="btn btn-outline" routerLink="/profile/my-ads">
          <i class="fas fa-list"></i> Mənim elanlarım
        </button>
        <button class="btn btn-outline" routerLink="/">
          <i class="fas fa-home"></i> Ana səhifəyə dön
        </button>
      </div>
    </div>
  </ng-template>
</div>
